import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';

@Injectable()
export class MessagePopupService {
	private readonly messageService = inject(MessageService);
	private readonly translateService = inject(TranslateService);

	info(summary: string, detail: string) {
		this.messageService.add({
			severity: 'info',
			summary: this.translateService.instant(summary),
			detail: this.translateService.instant(detail),
			life: 3000,
		});
	}

	error(summary: string, detail: string) {
		this.messageService.add({
			severity: 'error',
			summary: this.translateService.instant(summary),
			detail: this.translateService.instant(detail),
			life: 3000,
		});
	}
}
